"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.revenueAdjustmentNameMap = void 0;
const types_1 = require("@medely/types");
exports.revenueAdjustmentNameMap = new Map([
    [
        `RevenueAdjustment.adjustment_type.${types_1.AdjustmentType.VMS_FEE}`,
        'VMS fee',
    ],
    [
        `RevenueAdjustment.adjustment_type.${types_1.AdjustmentType.REBATE_PROMO_CREDIT}`,
        'Rebate promo credit',
    ],
    [
        `RevenueAdjustment.adjustment_type.${types_1.AdjustmentType.REBATE_FOUR_HOUR_MINIMUM}`,
        'Rebate - Scheduling Assurance',
    ],
    [
        `RevenueAdjustment.adjustment_type.${types_1.AdjustmentType.REBATE_LATE_CANCELLATION}`,
        'Late cancellation credit',
    ],
    [
        `RevenueAdjustment.adjustment_type.${types_1.AdjustmentType.REBATE_BETTER_PRO_EXPERIENCE}`,
        'Rebate better pro experience',
    ],
    [
        `RevenueAdjustment.adjustment_type.${types_1.AdjustmentType.HOURLY_PRO_INITIATED_ADJUSTMENT}`,
        'Hourly pro initiated adjustment',
    ],
    [
        `RevenueAdjustment.adjustment_type.${types_1.AdjustmentType.HOURLY_FACILITY_INITIATED_ADJUSTMENT}`,
        'Hourly facility initiated adjustment',
    ],
    [
        `RevenueAdjustment.adjustment_type.${types_1.AdjustmentType.WRITE_OFF_RECOVERY}`,
        'Write-off recovery',
    ],
    [
        `RevenueAdjustment.adjustment_type.${types_1.AdjustmentType.MEAL_PENALTY_FEE}`,
        'Meal Penalty',
    ],
]);
